import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinCustomerMenu = {
  async apiCustomerMenuExcel(arg = { method: 'get', params: {}, formData: {} }) {
    const config = {
      responseType: 'arraybuffer',
      header: {
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }
    const instance = axios.create(config)
    const [err, res] = await To(instance.get('/api/CustomerMenu/getemptyexceltemplateasync'))
    return Callback.globalCBForOld(err, res)
  },
  async apiCustomerMenu(arg = { method: 'list', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'patch':
        ;[err, res] = await To(
          wizStandardInstance.patch('/api/CustomerMenu/customer_menu', arg.params)
        )
        break
      case 'post':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/CustomerMenu/customer_menu', arg.params)
        )
        break
      case 'detail':
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/CustomerMenu/customer_menu/${arg.params.id}`))
        )
        break
      case 'delete':
        ;[err, res] = await To(
          wizStandardInstance.delete(encodeUrl(`/api/CustomerMenu/deleteasync/${arg.params.id}`))
        )
        break
      case 'importExcel':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/CustomerMenu/uploadexcelasync', arg.formData)
        )
        break
      case 'exportExcel':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/CustomerMenu/getexceltemplateasync/${arg.params.parentid || ' '}/${arg.params
                .id || ' '}/${arg.params.moduleId || ' '}/${arg.params.type || ' '}/${arg.params
                .projectName || ' '}`
            )
          )
        )
        break
      default:
        ;[err, res] = await To(
          wizStandardInstance.post('/api/CustomerMenu/query_customer_menu', arg.params)
        )
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinCustomerMenu,
}
